import Image from 'next/image'
import styled from 'styled-components'

export const SlideImage = styled(Image)`
  aspect-ratio: ${(props) =>
    (props.width as number) / (props.height as number)};
  max-width: ${(props) => props.width as number}px;
  width: 100%;
  min-width: 5px;
  height: auto;
  visibility: hidden;
`

export const FadeInContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: end;
  justify-content: end;
  flex: 1;
  align-items: center;
  gap: 8px;
  min-width: 100%;

  .hidden {
    display: none;
  }

  .invisible {
    visibility: hidden;
  }

  .fade-in {
    animation: animation-fade-in 0.5s forwards;
    opacity: 0;
  }

  .fade-out {
    animation: animation-fade-out 0.5s forwards;
    opacity: 1;
  }

  @keyframes animation-fade-in {
    0% {
      visibility: visible;
      transform: translate(10vw, 0);
      opacity: 0;
    }
    40% {
      opacity: 1;
    }
    100% {
      visibility: visible;
      transform: translate(0, 0);
      opacity: 1;
    }
  }

  @keyframes animation-fade-out {
    0% {
      visibility: visible;
      transform: translate(0, 0);
      opacity: 1;
    }
    100% {
      visibility: hidden;
      transform: translate(-10%, 0);
      opacity: 0;
    }
  }

  @media (max-width: 791px) {
    justify-content: center;
  }
`
